import React, { useState } from "react";
import StarRatings from "react-star-ratings";

const Rating = (props) => {
  const [isExpanded, setExpanded] = useState(false);

  const handleToggleExpand = () => {
    setExpanded(!isExpanded);
  };

  const trimmedReview =
    !isExpanded && props.review.length > 100
      ? `${props.review.slice(0, 100)}...`
      : props.review;

  const reviewDate = props.reviewDate;
  const date = new Date(reviewDate);

  const options = { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-GB", options);

  return (
    <div className="col-md-6 p-2 select-none ">
      <div className="card p-3 ">
        <h4>{props.sname}</h4>
        <StarRatings
          rating={props.stars}
          starRatedColor="green"
          numberOfStars={10}
          name="rating"
          starDimension="20px"
          starSpacing="4px"
        />
        <p className="mt-2">{trimmedReview}</p>
        {props?.review?.length > 100 ? (
          <span className="read-more" onClick={handleToggleExpand}>
            {isExpanded ? "Read Less" : "Read More"}
          </span>
        ) : (
          <div className="h-11"></div>
        )}
        <div className="flex justify-end">
          <span className="text-gray-400 ">{formattedDate}</span>
        </div>
      </div>
    </div>
  );
};

export default Rating;
